<!-- 上传多张图片 -->
<template>
  <el-upload
    v-loading.fullscreen.lock="loading"
    element-loading-text="文件上传中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.8)"
    class="avatar-uploader"
    :headers="uploadHeaders"
    :action="action"
    :show-file-list="false"
    multiple
    :on-success="handleAvatarSuccess"
    :before-upload="beforeAvatarUpload"
    accept="image/jpeg,image/png,image/jpg"
    name="File"
    :data="{ type: type }"
    :limit="10"
    :file-list="fileList"
  >
    <div v-if="imageUrlArr.length > 0" class="imgList">
      <div
        class="posR avatarBox mr8"
        v-for="(imageUrl, idx) in imageUrlArr"
        :key="idx"
      >
        <img :src="imageUrl" class="avatarImg" mode="aspectFill" />
        <div
          class="deleteIcon"
          v-if="showDelete"
          @click.stop="handleRemove(idx)"
        >
          <i class="el-icon-circle-close"></i>
        </div>
      </div>
    </div>
    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
  </el-upload>
</template>
<script>
import { uploadUrl } from "../../util/state";
export default {
  props: {
    showImage: {
      type: Boolean,
      default: true,
    },
    fileUrlArr: {
      type: Array,
      default: () => [],
    },
    fileType: {
      type: String,
      default: "image",
    },
    showDelete: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: "venue",
    },
  },
  data() {
    return {
      fileList: [],
      imageUrlArr: [],
      action: "",
      uploadHeaders: {},
      loading: false,
    };
  },

  created() {
    if (this.fileUrlArr) {
      this.imageUrlArr = this.fileUrlArr;
    } else {
      this.imageUrlArr = [];
    }
    this.uploadHeaders = { Authorization: "Bearer " + this.$store.state.token };
    this.action = uploadUrl;
  },
  methods: {
    handleRemove(idx) {
      this.imageUrlArr.splice(idx, 1);
      this.$emit("delete", this.imageUrlArr);
    },
    handleAvatarSuccess(res, file, fileList) {
      console.log(fileList);
      let list = fileList.map((item) => item.response.response[0]);
      this.loading = false;
      this.imageUrlArr = list;
      this.$emit("upload", list);
    },
    beforeAvatarUpload(file) {
      let isVideo = true;
      const isLt500M = file.size / 1024 / 1024 < 500;
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (this.fileType == "video") {
        isVideo = file.type === "video/mp4";
        if (!isVideo) {
          this.$message.error("上传视频只能是MP4,RMVB,AVI格式!");
          return false;
        }
        if (!isLt500M) {
          this.$message.error("上传视频大小不能超过500MB!");
          return false;
        }
      } else {
        if (!isLt50M) {
          this.$message.error("上传图片大小不能超过 50MB!");
        }
      }
      this.loading = true;
      return true;
    },
  },
};
</script>
<style lang="scss" scoped>
.imgList {
  display: flex;
  flex-wrap: wrap;
}
.posR {
  position: relative;
}
.deleteIcon {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: rgba($color: #000000, $alpha: 0.5);
  color: #ffffff;
  text-align: center;
  font-size: 16px;
  line-height: 22px;
  position: absolute;
  top: 5px;
  right: 5px;
  cursor: pointer;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 128px;
  height: 128px;
  line-height: 128px;
  text-align: center;
}
.avatarBox {
  width: 128px;
  height: 128px;
  display: block;
}
.avatarImg {
  width: 128px !important;
  height: 128px;
  display: block;
}
</style>
